import React from "react"
import styled, { css } from "styled-components"

import Button from "~/components/atoms/Button"
import FunctionLink from "~/components/atoms/FunctionLink"
import { Color, SpacingSize, TextSize, Transition } from "~/consts/style-mixins"

export type Action = {
  label: string
  action: Function
  className?: string
}

export type MainAction = Action & {
  disabled?: boolean
  isLoading?: boolean
  type?: "submit" | "reset" | "button"
}

interface Props {
  mainAction: MainAction
  subAction?: Action
  thirdAction?: Action
  vertical?: boolean
  horizontalReverse?: boolean
}

interface StyledProps {
  vertical?: boolean
  horizontalReverse?: boolean
  subActionLabel?: string
}

const ActionPairButton: React.VFC<Props> = ({ mainAction, subAction, thirdAction, vertical, horizontalReverse }) => {
  return (
    <>
      <StyledActionPairButtonWrapper vertical={vertical} horizontalReverse={horizontalReverse}>
        <StyledButtonWrapper vertical={vertical} subActionLabel={subAction && subAction.label}>
          <Button
            size="Medium"
            onClick={() => mainAction.action()}
            disabled={mainAction.disabled}
            className={mainAction.className}
            isLoading={mainAction.isLoading}
            type={mainAction.type}
          >
            {mainAction.label}
          </Button>
        </StyledButtonWrapper>
        {subAction && (
          <StyledFunctionLinkWrapper vertical={vertical}>
            <FunctionLink size="Medium" onClick={() => subAction.action()} className={subAction.className}>
              {subAction.label}
            </FunctionLink>
          </StyledFunctionLinkWrapper>
        )}
      </StyledActionPairButtonWrapper>
      {thirdAction && (
        <StyledThirdActionWrapper onClick={() => thirdAction.action()}>
          <div className="inner">{thirdAction.label}</div>
        </StyledThirdActionWrapper>
      )}
    </>
  )
}

const StyledActionPairButtonWrapper = styled.div`
  text-align: center;
  ${({ vertical }: StyledProps) => css`
    ${!vertical &&
    `
      display: flex;
      flex-flow: row-reverse;
      align-items: center;
      justify-content: space-between;
    `}
  `}
  ${({ horizontalReverse }: StyledProps) => css`
    ${horizontalReverse &&
    `
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: space-between;
    `}
  `}
`

const StyledButtonWrapper = styled.div`
  ${({ vertical, subActionLabel }: StyledProps) => css`
    ${vertical && subActionLabel && `margin-bottom: ${SpacingSize.M}px;`}
    ${!vertical && `width: 50%;`}
  `}
`

const StyledFunctionLinkWrapper = styled.div`
  ${({ vertical }: StyledProps) => css`
    ${!vertical && "width: 50%;"}
  `}
`

const StyledThirdActionWrapper = styled.div`
  cursor: pointer;
  text-align: center;
  border-top: 1px solid ${Color.BorderGray};
  margin-top: ${SpacingSize.M}px;
  color: ${Color.LightGray};
  font-size: ${TextSize.M};
  font-weight: bold;
  ${Transition.Hover};
  .inner {
    margin: ${SpacingSize.M}px 0 0;
  }
  &:hover {
    color: ${Color.Gray};
  }
`

export default ActionPairButton
